<script>
  import { createEventDispatcher } from 'svelte';

  export let theme = 'dark';

  const dispatch = createEventDispatcher();

  function handleClick() {
    dispatch('click');
  }
</script>

<button class={`scroll-btn ${theme}`} on:click={handleClick} />

<style lang="scss">
  .scroll-btn {
    display: block;
    position: relative;

    width: 2.6rem;
    height: 3.7rem;

    border-radius: 2rem;
    border: 2px solid transparent;

    &.light {
      border-color: rgb(var(--white));

      &::after {
        background-color: rgb(var(--white));
      }
    }

    &.dark {
      border-color: var(--primary);

      &::after {
        background-color: var(--primary);
      }
    }

    &::after {
      content: '';
      display: block;
      position: absolute;

      top: 0.6rem;
      left: 0.9rem;

      width: 0.4rem;
      height: 0.4rem;

      border-radius: 50%;

      transition: transform 0.2s;
    }

    &:hover {
      &::after {
        transform: translateY(1.8rem);
      }
    }
  }
</style>
